import EventLogo from './EventLogo';

export default EventLogo;
